import { useEffect, useRef } from 'react'

export const useCancellableDelay = (): {
    wait: (ms: number) => Promise<void>
    isCancelled: () => boolean
} => {
    const mountedRef = useRef(true)
    const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null)
    const resolveRef = useRef<(() => void) | null>(null)

    useEffect(() => {
        return () => {
            mountedRef.current = false
            if (timeoutId.current) {
                clearTimeout(timeoutId.current)
                timeoutId.current = null
            }
            if (resolveRef.current) {
                resolveRef.current()
                resolveRef.current = null
            }
        }
    }, [])

    const wait = (ms: number) =>
        new Promise<void>((resolve) => {
            resolveRef.current = resolve
            timeoutId.current = setTimeout(resolve, ms)
        })

    const isCancelled = () => !mountedRef.current

    return { wait, isCancelled }
}
